// Matches PHP implementation from AppServiceProvider.php
// For Blade::directive('replaceYearWithCurrent')
export const replaceYearWithCurrent = (() => {
	const currentYear = new Date().getFullYear();
	const startYear = 2020;

	// Example: if current year is 2025, this creates: /\b(2020|2021|2022|2023|2024|2025)\b/g
	const yearsPattern = [];
	for (let year = startYear; year <= currentYear; year++) {
		yearsPattern.push(year);
	}
	const yearRegex = new RegExp(`\\b(${yearsPattern.join("|")})\\b`, "g");

	return (text) => {
		if (!text) return text;
		return text.replace(yearRegex, currentYear);
	};
})();
